module.exports = __webpack_public_path__ + "static/media/gucci.21c49018.png";